import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Button } from 'components/misc'
import { scrollToElement } from 'utils/scroll'
import styles from './form-button.styl'

export default class FormButton extends Component {
  static propTypes = {
    pristine: PropTypes.bool,
    simple: PropTypes.bool,
    invalid: PropTypes.bool,
    // submitSucceeded: React.PropTypes.bool.isRequired,
    submitFailed: PropTypes.bool,
    children: PropTypes.any,
    inline: PropTypes.bool
  }

  static defaultProps = {
    simple: false
  }

  render() {
    const { pristine, submitFailed, invalid, simple, inline } = this.props

    return (
      <div className={[styles.wrapper, inline && styles.inline].join(' ')}>
        {!pristine &&
          !simple &&
          <span>
            {!submitFailed &&
              <span className={styles.note}>Pending changes ...</span>}
            {invalid &&
              submitFailed &&
              <span className={`${styles.note} ${styles.hasError}`}>
                Some
                {' '}
                <span className={styles.btn} onClick={() => scrollToElement()}>
                  fields
                </span>
                {' '}
                require your attention
              </span>}
          </span>}
        <Button {...this.props} disabled={pristine}>
          {this.props.children}
        </Button>
      </div>
    )
  }
}
